import { gql } from "@apollo/client";import { useMutation } from "@apollo/client/react";import React, { useContext, useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import { Context } from '../../../context/context';

import toast, { Toaster } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import ImageUploader from 'react-images-upload';
import { obtenerDataImagen } from '../../../actions/ImagenAction';
import ErrorDialog from '../../../components/ErrorDialog';
import { CustomButton } from '../../../components/customButton/CustomButton';

export default function ConfiguracionUsuario() {
  const [context] = useContext(Context);

  // dlg de error
  const [opendDlgError, setOpenDlgError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");

  useEffect(() => {
    setOpenDlgError(mensajeError !== "");
  }, [mensajeError]);

  const handleCloseDlgError = () => {
    setOpenDlgError(false);
  };

  const navigate = useNavigate();

  const [usuario, setUsuario] = useState({
    showDelete: true,
    imagenPerfil: {
      data: '',
      nombre: '',
      extension: '',
      tipo: ''
    },
    imagenUrl: '',
    imagen: ''
  });

  const MConfigUsuario = gql`
    mutation MConfigUsuario($idUsuario: Int!, $contentType: String!, $imagen: String!, $extension: String!){    
        saveConfiguracionUsuario(configuracion: { idUsuario: $idUsuario, contentType: $contentType, imagenPerfil: $imagen, imagenExtension: $extension }) 
        {
            success,
            error,
            valorEsperado
        }
    }`;

  const DConfigUsuario = gql`
    mutation DConfigUsuario($idUsuario: Int!){    
        deleteConfiguracionUsuario(idUsuario: $idUsuario) 
        {
            success,
            error,
            valorEsperado
        }
    }`;

  const [saveConfiguracion, { loading, error, data }] = useMutation(MConfigUsuario, {
    onCompleted: (data) => {
      if (data.saveConfiguracionUsuario.success) {
        if (data.saveConfiguracionUsuario.valorEsperado)
        {
          toast.success("Se actualizó correctamente la imagen.");
          setTimeout(() => {
            navigate('/menu');
          }, 2000);
        } else

        toast.error(data.saveConfiguracionUsuario.error);
      } else

      setMensajeError(data.saveConfiguracionUsuario.error);
    },
    onError: (data) => {
      setMensajeError("ERRORDB");
    }
  });

  const [deleteConfiguracion, { loadingD, errorD, dataD }] = useMutation(DConfigUsuario, {
    onCompleted: (dataD) => {
      if (dataD.deleteConfiguracionUsuario.success) {
        if (dataD.deleteConfiguracionUsuario.valorEsperado)
        {
          toast.success("Se eliminó correctamente la imagen.");
          setTimeout(() => {
            navigate('/menu');
          }, 2000);
        } else

        toast.error(dataD.deleteConfiguracionUsuario.error);
      } else

      setMensajeError(dataD.deleteConfiguracionUsuario.error);
    },
    onError: (dataD) => {
      setMensajeError("ERRORDB");
    }
  });

  const handleClick = () => {
    if (isFormValid()) {
      SubirArchivo();
    }
  };

  const handleClickDelete = () => {
    EliminarArchivo();
  };

  const isFormValid = () => {
    if (usuario.imagenPerfil.data.length === 0) {
      toast.error('Debe seleccionar una imagen de perfil correcta.');
      return false;
    } else {
      return true;
    }
  };

  const SubirArchivo = () => {

    if (usuario.imagenPerfil.data === '') {
      sessionStorage.setItem('imagenPerfil', '');
    }

    sessionStorage.setItem('imagenPerfilTipo', '');
    sessionStorage.setItem('imagenPerfilDecode', '');
    let idUsuario = parseInt(sessionStorage.getItem('idUsuario'));
    let result = saveConfiguracion({ variables: { idUsuario: idUsuario,
        contentType: usuario.imagenPerfil.tipo,
        imagen: usuario.imagenPerfil.data,
        extension: usuario.imagenPerfil.extension
      } });
  };

  const EliminarArchivo = () => {
    sessionStorage.setItem('imagenPerfil', '');
    sessionStorage.setItem('imagenPerfilTipo', '');
    sessionStorage.setItem('imagenPerfilDecode', '');
    let idUsuario = parseInt(sessionStorage.getItem('idUsuario'));
    let result = deleteConfiguracion({ variables: { idUsuario: idUsuario } });
  };

  const handleSubirFoto = (imagenes) => {

    if (imagenes.length > 0) {
      const imagen = imagenes[0];
      const imagenUrl = URL.createObjectURL(imagen);

      sessionStorage.setItem('imagenPerfil', imagenUrl);

      obtenerDataImagen(imagen).then((respuesta) => {
        console.log('respuesta: ', respuesta);
        setUsuario((anterior) => ({
          ...anterior,
          showDelete: false,
          imagenPerfil: respuesta,
          imagenUrl: imagenUrl,
          imagen: imagen
        }));
      });
    } else
    {
      setUsuario((anterior) => ({
        ...anterior,
        showDelete: true,
        imagenPerfil: {
          data: '',
          nombre: '',
          extension: '',
          tipo: ''
        },
        imagenUrl: '',
        imagen: ''
      }));
    }
  };

  return (
    <>      
        <div className='section-content'>   
                        <ImageUploader
          withPreview={true}
          withIcon={true}
          //key = {fotoKey}
          singleImage={true}
          fileContainerStyle={{ width: '40%', height: '30%', background: 'rgb(238, 238, 238)' }}
          buttonText="Seleccione una imagen de perfil"
          buttonStyles={{ background: '#1976d2' }}
          onChange={handleSubirFoto}
          imgExtension={[".jpg", ".png", ".jpeg"]}
          maxFileSize={1048576}
          label="Tamaño Máximo: 1.0MB., Formatos: .jpg; .png; .jpeg"
          labelClass='imageUploader-label-class'
          fileTypeError='El formato del archivo es incorrecto'
          fileSizeError='El tamaño del archivo es incorrecto'
          errorClass='imageUploader-error-class' />
             
                        <CustomButton
          variant="contained"
          size="small"
          onClick={handleClick}
          endIcon={<SaveIcon />}>
          Guardar</CustomButton>  
                         &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                         {usuario.showDelete &&
        <CustomButton
          variant="contained"
          size="small"
          color="error"
          onClick={handleClickDelete}
          endIcon={<DeleteIcon />}>
          Eliminar</CustomButton>
        }           

            <ErrorDialog
          id="dlg-error-cfgUser"
          open={opendDlgError}
          onClose={handleCloseDlgError}
          mensaje={mensajeError} />
        
            </div> 
        </>);

};